/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { SubmitModuleFeedbackScoring } from './submitModuleFeedbackScoring';
import type { SubmitModuleFeedbackGrade } from './submitModuleFeedbackGrade';
import type { SubmitModuleFeedbackEvaluatorId } from './submitModuleFeedbackEvaluatorId';

/**
 * Grading and feedback structure for module submissions
 */
export interface SubmitModuleFeedback {
  feedback: string;
  scoring?: SubmitModuleFeedbackScoring;
  grade?: SubmitModuleFeedbackGrade;
  manualGrade?: boolean;
  evaluatorId?: SubmitModuleFeedbackEvaluatorId;
}
